import React from "react";
import FlipCardSlider from "../../components/Slider/FlipCardSlider";
import ArticleContainer from "../../components/Article/ArticleContainer";
import ArticleHero from "../../components/Hero/ArticleHero";
const relatedBlogs = [
  {
    contentType: "BLOG",
    title: "Complimenting Fleet Modernization with Road Safety",
    description: "Shoora is leading the charge in transforming fleet operations by enhancing safety and operational efficiency through the Voluntary Vehicle-Fleet Modernization Programme (VVMP).",
    link: "/insights/blog/complimenting-fleet-modernization-with-road-safety",
    linkText: "Read article",
    thumbnail:
      "https://images.pexels.com/photos/11389692/pexels-photo-11389692.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
  readTime: 10,
    },
  {
    contentType: "BLOG",
    title: "Envisioning the Future of Mobility with Shoora",
    description:
      "Shoora offers comprehensive fleet management solutions that track vehicle locations, monitor driver performance, optimise routes, and reduce fuel consumption.",
    thumbnail:
      "/images/thumbnails/14.jpeg",
    link: "/insights/blog/envisioning-the-future-of-mobility-with-shoora",
  readTime: 10,
  },
  {
    contentType: "BLOG",
    title: "Leverage AIS-140’s Mandate for Telematics Devices",
    description:
      "Shoora, a leader in advanced video telematics solutions , is committed to harnessing the potential of this mandate to create safer roads and smarter transportation systems.",
    thumbnail: "https://www.easyembedded.net/images/ais2.jpg",
    link: "/insights/blog/how-shoora-aims-to-leverage-ais-140s-mandate-for-telematics-devices-in-public-transportation-and-commercial-vehicles",
  readTime: 10,
  },
  {
    contentType: "BLOG",
    title: "Tackling Distracted Driving: Transforming Fleet Safety",
    description:
      "By adopting the Three Ts—Talk, Train, and Track, Shoora addresses distracted driving head-on, protecting lives and optimising operations.",
    thumbnail: "/images/thumbnails/3.jpeg",
    link: "/insights/blog/tackling-distracted-driving-transforming-fleet-safety",
  readTime: 10,
  },
  {
    contentType: "BLOG",
    title: "Truck Driver Safety Tips: A Guide to Protecting Lives on the Road",
    description:
      "Shoora, through its advanced video telematics solutions, is helping to curb these numbers and protect lives.",
    thumbnail:
      "https://images.pexels.com/photos/27946843/pexels-photo-27946843/free-photo-of-truck-rearview-mirror.jpeg?auto=compress&cs=tinysrgb&w=600",
    link: "/insights/blog/truck-driver-safety-tips-a-guide-to-protecting-lives-on-the-road",
  readTime: 10,
  },
 

  {
    contentType: "CUSTOMER STORY",
    title: "Kapoor Diesels Truck Achieves 1,60,200 Accident-Free Kilometres",
    description:
      "The integrated suite of technologies offered Kapoor Diesel enhanced safety, better fleet management, and measurable cost savings.",
    thumbnail: "/images/thumbnails/15.jpeg",
    link: "/insights/customer-stories/kapoor-diesel-fleet-achieves-60200-accident-free-kilometres-with-shooras-cutting-edge-video-telematics-solutions",
  readTime: 10,
  },
];
const data = {
  contentType: "CUSTOMER STORY",
  title:
    "How Shoora Life Savers Helped BLR Logistics Avert Over 7,500 Accidents",
  description:
    "Shoora is not just a service provider for BLR Logistics; they are a trusted safety partner.",
  author: "Abhishek Goyal, Operations Head, BLR Logistics",
  createdOn: "26th Oct, 2024",
  imgsrc:
    "https://images.jdmagicbox.com/v2/comp/mumbai/26/022p1955726/catalogue/blr-logistics-india-ltd-goregaon-east-mumbai-transporters-for-all-india-3m98o5wutw.jpg",
  readTime: 10,
  content: `
    <p>
        At BLR Logistics, safety is paramount. Managing a fleet of over 500
        vehicles navigating India's challenging roads, we faced constant risks:
        accidents, cargo theft, and driver fatigue. Partnering with Shoora
        transformed our operations.
        <br />
        <br />
        Shoora's <strong>RoadSense™</strong> and <strong>CabinVision™ dash cams</strong>, paired with their <strong>24/7 dedicated Control Room team</strong>, became game-changers.
        Their AI-powered systems provided real-time alerts—collision warnings,
        distracted driving detection, and lane departure alerts. But what truly
        stood out was Shoora Life Savers, their highly trained control room
        team.
        <br />
        <br />
        Every alert was met with instant action. When a driver showed signs of
        fatigue or a collision risk was detected, Shoora Life Savers engaged via
        the in-vehicle two-way communication system, providing real-time
        guidance and corrective feedback. Over the past year, this proactive
        monitoring helped us avert <strong>more than 7,500 accidents in 6 months</strong>, safeguarding
        lives and ensuring on-time deliveries.
        <br />
        <br />
        The instant video retrieval feature also helped us resolve false
        accident claims, saving us millions in liability costs. Shoora didn't
        just provide technology—they delivered peace of mind. Their partnership
        ensures that every mile our fleet travels is safer than ever.
        <br />
        <br />
        Shoora is not just a service provider for BLR Logistics; they are a
        trusted safety partner.
      </p>
   `,
};
const BLRLogistics = () => {
  return (
    <>
      <ArticleHero
        contentType={data?.contentType}
        title={data?.title}
        createdOn={data?.createdOn}
        imgsrc="/images/about/bg8.webp"
        customStyle={{
          title: {
            fontSize: "45px",
          },
        }}
      />
      <div className="bg-dark">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a href="#">Home</a>
              </li>
              <li class="breadcrumb-item">
                <a href="#">Insights</a>
              </li>
              <li class="breadcrumb-item">
                <a href="#" className="text-capitalize">
                  {data?.contentType}s
                </a>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                {data?.title}
              </li>
            </ol>
          </nav>
        </div>
      </div>

      

      <ArticleContainer data={data} />
      <hr className="border-3" style={{ borderColor: "var(--accent-color)" }} />
      <div
                className="stories-section section my-5"
                style={{ maxWidth: "100%" }}
            >
                <div className="container">
                    
                <FlipCardSlider data={relatedBlogs} title={"You may also like"}/>
                </div>
            </div>
    </>
  );
};

export default BLRLogistics;
